<template>
  <div class="navbarBox">
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <!--<breadcrumb class="breadcrumb-container"></breadcrumb>-->
      <el-dropdown class="avatar-container" trigger="click" style="top: -12px;">
        <div class="avatar-wrapper">
          <!--<img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">-->
          <i class="el-icon-caret-bottom" style="width: 120px;"><span style="display: inline-block;margin-left: 10px;">{{userName}}</span></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/welcome">
            <el-dropdown-item>
              主页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="modifyPwd = true">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            退出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <el-dialog title="修改密码" :visible.sync="modifyPwd" width="25%" id="modifyDialog" :append-to-body="true" center
               @close="clearFrom">
      <el-form :model="modifyForm" :rules="rules" ref="modifyForm" v-if="!checkOldPwd">
        <el-form-item prop="oldpass" label="原始密码:" :label-width="formLabelWidth">
          <el-input type="password" v-model="modifyForm.oldpass" autoComplete="on"
                    placeholder="请输入原始密码"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="modifyForm1" :rules="rules1" ref="modifyForm1" v-else>
        <el-form-item label="姓名:" :label-width="formLabelWidth">
          <span>{{modifyForm1.userName}}</span>
        </el-form-item>
        <el-form-item label="登录账号:" :label-width="formLabelWidth">
          <span>{{modifyForm1.name}}</span>
        </el-form-item>
        <el-form-item prop="pass" label="新密码:" :label-width="formLabelWidth">
          <el-input type="password" v-model="modifyForm1.pass" autoComplete="on"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label="重复新密码:" :label-width="formLabelWidth">
          <el-input type="password" v-model="modifyForm1.checkPass" autoComplete="on"
                    placeholder="请再输入一次新密码"></el-input>
        </el-form-item>
        <el-alert
          title="密码由大小写字母、数字中至少两种组成，长度在6~20位之间"
          type="warning">
        </el-alert>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearFrom()">取 消</el-button>
        <el-button type="primary" @click="submitForm('modifyForm')" v-if="!checkOldPwd">验 证</el-button>
        <el-button type="primary" @click="checkPass('modifyForm1')" v-if="checkOldPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import {getUserName} from "@/utils/auth";
  import {Message} from 'element-ui'
  // import {modifyPassWord, queryPersonDetails, updatePersonInfo} from "@/api/login"

  export default {
    data() {
      let validateOldpass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入原始密码'));
        } else {
          callback();
        }
      };
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6 || value.length > 20) {
          callback(new Error('密码长度为6~20位之间'));
        } else if (!/([a-zA-Z]+[0-9]+)|([0-9]+[a-zA-Z]+)/
            .test(value)) {
          callback(new Error('密码格式为数字加字母'));
        } else if (value == this.modifyForm.oldpass) {
          callback(new Error('新旧密码不可以一致'));
        } else {
          if (this.modifyForm1.checkPass !== '') {
            this.$refs.modifyForm1.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value.length < 6 || value.length > 20) {
          callback(new Error('密码长度为6~20位之间'));
        } else if (!/([a-zA-Z]+[0-9]+)|([0-9]+[a-zA-Z]+)/
            .test(value)) {
          callback(new Error('密码格式为数字加字母'));
        } else if (value !== this.modifyForm1.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        userName: '',
        modifyPwd: false,
        formLabelWidth: '110px',
        modifyForm: {
          oldpass: '',
        },
        modifyForm1: {
          pass: '',
          checkPass: '',
          name: '',
          userName: ''
        },
        rules: {
          oldpass: [
            {validator: validateOldpass, trigger: 'change'}
          ],
        },
        rules1: {
          pass: [
            {validator: validatePass, trigger: 'change'}
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'change'}
          ],
        },
        checkOldPwd: false,
        userId: ''
      }
    },
    components: {
      Breadcrumb,
      Hamburger
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar'
      ])
    },
    mounted() {
      this.userName = window.localStorage.getItem('names') || '';
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      logout() {
        this.$store.dispatch('clear').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$ajax.post(this.$url.login.checkPassword, {'password': this.modifyForm.oldpass, 'loginName': window.sessionStorage.getItem('loginName')}).then(res => {
              console.log(res);
              if (res.resultCode == '0000') {
                this.modifyForm1.userName = res.user.realName;
                this.modifyForm1.name = res.user.name;
                this.userId = res.user.id;
                this.checkOldPwd = true;
              } else if (res.resultCode == '0002') {
                Message.error('原始密码错误');
              } else {
                Message.error(res.resultMsg);
              }
            })
          } else {
            console.log('提交失败!!');
            return false;
          }
        });
      },
      checkPass(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$ajax.post(this.$url.login.updatePassword, {'password': this.modifyForm1.checkPass, 'userId': this.userId}).then(res => {
              console.log(res);
              if (res.resultCode == '0000') {
                Message.success("修改成功");
                this.clearFrom();
              } else {
                Message.error(res.resultMsg);
              }
            })
          } else {
            console.log('提交失败!');
            return false;
          }
        });
      },
      clearFrom() {
        this.checkOldPwd = false;
        this.modifyPwd = false;
        this.modifyForm.oldpass = '';
        this.modifyForm1.pass = '';
        this.modifyForm1.checkPass = '';
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbarBox {
    -webkit-transition: width .28s;
    transition: width .28s;
    width: calc(100% - 180px);
    background: #ffffff;
    position: fixed;
    right: 0;
    z-index: 99;
  }

  #app .hideSidebar .navbarBox .navbar {
    margin-left: 40px !important;
  }

  .navbar {
    -webkit-transition: margin-left .28s;
    transition: margin-left .28s;
    /*margin-left: 10px;*/
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }
    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    #modifyDialog {
      .el-input {
        width: auto;
      }
      .el-alert {
        margin-top: 40px;
      }
    }
  }

  .el-dialog--center .el-dialog__body span {
    text-align: left;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue